export default {
  data() {
    return {
      googleAddressDetails: {
        address_line_1: '',
        city: '',
        state: '',
        zip: '',
        country: '',
      },
      googlePlaceID: '',
      googleFormattedAddress: '',
      googleMapsLoadingPromise: null,
    }
  },
  methods: {
    loadGoogleMapsAPI() {
      if (window.google && window.google.maps) {
        return Promise.resolve(window.google.maps)
      }

      if (this.googleMapsLoadingPromise) {
        return this.googleMapsLoadingPromise
      }

      this.googleMapsLoadingPromise = new Promise((resolve, reject) => {
        const scriptId = 'google-maps-api'
        if (document.getElementById(scriptId)) {
          const checkGoogle = () => {
            if (window.google && window.google.maps) resolve(window.google.maps)
            else setTimeout(checkGoogle, 50)
          }
          checkGoogle()
          return
        }

        const script = document.createElement('script')
        script.id = scriptId
        const apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY
        const libraries = 'places'

        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${libraries}&v=beta&callback=initGoogleMaps`
        script.async = true
        script.defer = true

        window.initGoogleMaps = () => {
          resolve(window.google.maps)
        }

        script.onerror = () => {
          reject(new Error('Google Maps script failed to load.'))
        }

        document.head.appendChild(script)
      })
      return this.googleMapsLoadingPromise
    },
    attachPlaceSelectListener(listenerMethod, elementId) {
      const autocompleteElement = document.getElementById(elementId)
      if (autocompleteElement) {
        autocompleteElement.addEventListener('gmp-select', listenerMethod)
      } else {
        console.error('Element <gmp-place-autocomplete> not found in DOM.')
      }
    },
    async fetchPlaceDetails(place) {
      await place.fetchFields({
        fields: ['id', 'displayName', 'formattedAddress', 'location', 'addressComponents'],
      })

      this.googlePlaceID = place.id
      this.googleFormattedAddress = place.formattedAddress

      if (place.addressComponents) {
        for (const component of place.addressComponents) {
          const value = component.longText || component.shortText

          const type = component.types[0]

          switch (type) {
            case 'street_number':
              this.googleAddressDetails.street_number = value
              break
            case 'route':
              this.googleAddressDetails.route = value
              break
            case 'locality':
            case 'postal_town':
              this.googleAddressDetails.city = value
              break
            case 'administrative_area_level_1':
              this.googleAddressDetails.state = component.shortText
              break
            case 'country':
              this.googleAddressDetails.country = value
              break
            case 'postal_code':
              this.googleAddressDetails.zip = value
              break
            default:
              break
          }
        }
      }

      this.googleAddressDetails.address_line_1 = [
        this.googleAddressDetails.route,
        this.googleAddressDetails.street_number
      ].filter(Boolean).join(' ').trim()

      delete this.googleAddressDetails.street_number
      delete this.googleAddressDetails.route
    },

    // async validateAddressWithGoogle(address) {
    //   /*
    //     address = {
    //       address_line_1: '',
    //       city: '',
    //       state: '',
    //       zip: '',
    //       country: '',
    //       countryCode: 'PH' // ISO-2 (ВАЖНО)
    //     }
    //   */
    //
    //   const addressString = [
    //     address.address_line_1,
    //     address.city,
    //     address.state,
    //     address.zip,
    //     address.country
    //   ].filter(Boolean).join(', ')
    //
    //   const payload = {
    //     address: {
    //       regionCode: address.countryCode,
    //       addressLines: [addressString]
    //     }
    //   }
    //
    //   try {
    //     const response = await fetch(
    //       `https://addressvalidation.googleapis.com/v1:validateAddress?key=${process.env.VUE_APP_GOOGLE_API_KEY}`,
    //       {
    //         method: 'POST',
    //         headers: {
    //           'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify(payload)
    //       }
    //     )
    //
    //     const data = await response.json()
    //
    //     if (!data.result) {
    //       return {
    //         valid: false,
    //         reason: 'NO_RESULT',
    //         raw: data
    //       }
    //     }
    //
    //     const { verdict, address: validatedAddress } = data.result
    //
    //     return {
    //       valid: verdict.addressComplete === true,
    //       hasUnconfirmedComponents: verdict.hasUnconfirmedComponents,
    //       validationGranularity: verdict.validationGranularity,
    //       suggestedAddress: validatedAddress.formattedAddress,
    //       addressComponents: validatedAddress.addressComponents,
    //       raw: data.result
    //     }
    //
    //   } catch (error) {
    //     console.error('Google address validation failed', error)
    //
    //     return {
    //       valid: false,
    //       reason: 'REQUEST_FAILED',
    //       error
    //     }
    //   }
    // }
  },
}